import { MIL } from "@/services/PreLayout/PreLayoutLibrary";
import { SINGLE, DIFF } from "@/constants/libraryConstants";
import { DDR3, DDR3L, DDR4, LPDDR4, LPDDR5 } from '../constants';
import { CAPACITOR, INDUCTOR, RESISTOR } from '@/services/PreLayout';
import { unitChange } from '../../helper/mathHelper';
import { PACKAGE } from "../../../constants/treeConstants";

export const SCHEMATIC = 'Schematic', MODEL = 'Model',
  FLYBY = 'Fly-by', T = 'T', POINT_TO_POINT = 'Point-to-Point',
  X8 = 'x8', X16 = 'x16', X32 = "x32", X64 = "x64",
  CONTROLLER = 'Controller', MEMORY = 'Memory';

// config
export const PRELAYOUT = 'prelayout',
  UNIT = 'unit',
  WIDTH = 'width',
  TOPOLOGY = 'topology',
  MEMORYS = 'memory',
  NUMBER_OF_CHANNEL = 'numberOfChannel',
  INCLUDES_RES = 'includeRes';

// config list
export const
  preLayoutTypes = [SCHEMATIC, MODEL],
  topologyType = [FLYBY],
  LPDDRTopologyType = [T, POINT_TO_POINT],
  memoryBus = [X8, X16],
  packageDieBus = [X8, X16, X32],
  lpddr5PackageDieBus = [X16, X32, X64];

// columns dataIndex
export const
  BYTE = 'byte',
  NET = 'net',
  INSERTIONLOSS = 'insertionLoss',
  CLK = 'CLK',
  ADR = 'ADR',
  CMD = 'CMD',
  DQS = 'DQS',
  SIGNALSPACING = 'signal_spacing',
  SIGNAL = 'signal',
  WCK = 'WCK',
  RDQS = 'RDQS'

export const PTR = 'parallel-termination-resistor';

// signals
export const
  BYTE_NETS = ['DQS', 'DQ0', 'DQ1', 'DQ2', 'DQ3', 'DQ4', 'DQ5', 'DQ6', 'DQ7', 'DM'],
  BYTE_PINS = ['DQSP', 'DQSN', 'DQ0', 'DQ1', 'DQ2', 'DQ3', 'DQ4', 'DQ5', 'DQ6', 'DQ7', 'DM'],
  CLK_NETS = ['CLK'],
  CLK_PINS = ['CLKP', 'CLKN'],
  DDR3_ADR = ['A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'A9', 'A10', 'A11', 'A12', 'A13'],
  DDR3_CMD = ['BA0', 'BA1', 'BA2', 'RAS', 'CAS', 'WE', 'CS', 'CKE', 'ODT'],
  DDR4_ADR = ['A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'A9', 'A10', 'A11', 'A12', 'A13', 'A14', 'A15', 'A16'],
  DDR4_CMD_78 = ['BA0', 'BA1', 'CS', 'CKE', 'ODT', 'BG0', 'BG1', 'ACT'],
  DDR4_CMD_96 = ['BA0', 'BA1', 'CS', 'CKE', 'ODT', 'BG0', 'ACT'],
  LPDDR4_ADR = ['CA0', 'CA1', 'CA2', 'CA3', 'CA4', 'CA5'],
  LPDDR4_CMD = ['CS0', 'CS1', 'CKE0', 'CKE1'],
  DDR5_ADR = ['CA0', 'CA1', 'CA2', 'CA3', 'CA4', 'CA5', 'CA6', 'CA7', 'CA8', 'CA9', 'CA10', 'CA11', 'CA12', 'CA13', 'CS0'],
  LPDDR5_BYTE_NETS = ['RDQS', 'WCK', 'DQ0', 'DQ1', 'DQ2', 'DQ3', 'DQ4', 'DQ5', 'DQ6', 'DQ7', 'DM'],
  LPDDR5_BYTE_PINS = ['RDQST', 'RDQSC', 'WCKT', 'WCKC', 'DQ0', 'DQ1', 'DQ2', 'DQ3', 'DQ4', 'DQ5', 'DQ6', 'DQ7', 'DM'],
  LPDDR5_ADR = ['CA0', 'CA1', 'CA2', 'CA3', 'CA4', 'CA5', 'CA6'],
  RLCList = [CAPACITOR, INDUCTOR, RESISTOR];

// default library file
export const
  Library_constant = {
    "id": "",
    "name": "",
    "fileName": ""
  },
  Microstrip_constant = {
    "LossTangent": "0.005",
    "Thickness": 1.6,
    "Z0": "58.041",
    "Conductivity": "5.959e7",
    "Height": 5,
    "Unit": "mil",
    "Er": "3.5",
    "Width": 7.75,
    "Spacing": 5,
    "type": SINGLE
  },
  Microstrip_DIFF = {
    "Z0": "59.9482",
    "Zdiff": "93.0444",
    "type": DIFF
  },
  Stripline_constant = {
    "LossTangent": "0.005",
    "Thickness": 0.6,
    "Z0": "39.4458",
    "Conductivity": "5.959e7",
    "Height1": 3,
    "Height2": 9.5,
    "Unit": "mil",
    "Er": "4.2",
    "Width": 5.6,
    "Spacing": 5,
    "type": SINGLE
  },
  Stripline_DIFF = {
    "Z0": "40.5935",
    "Zdiff": "71.2907",
    "type": DIFF
  },
  Via_constant = {
    "PlatingThickness": 2,
    "AntiPadDiameter": 40,
    "PadDiameter": 20,
    "ViaToViaPitch": 12.75,
    "Unit": "mil",
    "DrillDiameter": 10,
    "Er": "3.6"
  };

// default library file data 
function getLibraryData(unit) {
  const via_template = getNewUnitData(unit, Via_constant);
  const Via = { ...Library_constant, libraryData: { ...via_template, ViaToViaPitch: "" } };
  const Via_diff = { ...Library_constant, libraryData: { ...via_template } };
  const microstrip_template = getNewUnitData(unit, Microstrip_constant);
  const Microstrip = { ...Library_constant, libraryData: { ...microstrip_template } };
  const Microstrip_diff = { ...Library_constant, libraryData: { ...microstrip_template, ...Microstrip_DIFF } };
  delete Microstrip.libraryData.Spacing;
  const stripline_template = getNewUnitData(unit, Stripline_constant);
  const Stripline = { ...Library_constant, libraryData: { ...stripline_template } };
  const Stripline_diff = { ...Library_constant, libraryData: { ...stripline_template, ...Stripline_DIFF } };
  delete Stripline.libraryData.Spacing;
  return { Via, Via_diff, Microstrip, Microstrip_diff, Stripline, Stripline_diff }
}

function getNewUnitData(unit, data) {
  let newData = {}
  for (let key in data) {
    let value = data[key];
    if (typeof value === 'number') {
      value = unitChange({ num: value, newUnit: unit, decimals: 4 }).number;
    } else if (key === 'Unit') {
      value = unit;
    }
    newData[key] = value.toString();
  }
  return newData;
}

// Signal class
function PreLayoutSignal({ name, index, sections = [], nets, channel = "" }) {
  this.name = name;
  this.index = index;
  this.sections = sections && sections.length === 0 ? [] : sections;
  this.insertionLoss = "";
  this.nets = [nets]; //["net"]
  if (channel) {
    this.nets = [`${nets}${channel}`];
  }
}

// Diff signal class
function PreLayoutDiffSignal({ name, index, sections = [], nets, channel = "" }) {
  this.name = name;
  this.index = index;
  this.sections = sections && sections.length === 0 ? [] : sections;
  this.insertionLoss = "";
  this.nets_N = [`${nets}N`];
  this.nets_P = [`${nets}P`];
  if (channel) {
    if (nets.match(RDQS) || nets.match(WCK)) {
      this.nets_N = [`${nets}C${channel}`];
      this.nets_P = [`${nets}T${channel}`];
    } else {
      this.nets_N = [`${nets}N${channel}`];
      this.nets_P = [`${nets}P${channel}`];
    }
  }
}

// pre layout class
function DefaultPreLayout({ type, component, pcbType }) {
  this.prelayout = SCHEMATIC;
  this.type = type;
  this.unit = MIL;
  this.memory = 1;
  this.width = pcbType === PACKAGE && [LPDDR4, LPDDR5].includes(type) ? X32 : X16;
  this.topology = [LPDDR4, LPDDR5].includes(type) ? POINT_TO_POINT : FLYBY;
  this.lib = "";
  this.models = [];
  this.signal_groups = [];
  this.components = component;
  this.numberOfChannel = [LPDDR4, LPDDR5].includes(type) ? 2 : 1;
}

function DefaultModelPreLayout({ type, component, pcbType }) {
  this.prelayout = MODEL;
  this.type = type;
  this.memory = null;
  this.topology = [LPDDR4, LPDDR5].includes(type) ? POINT_TO_POINT : FLYBY;
  this.models = [];
  this.components = component;
  this.numberOfChannel = '';
  this.width = pcbType === PACKAGE && [LPDDR4, LPDDR5].includes(type) ? X32 : X16;
  this.packageId = "";
  this.includeRes = false;
}

// memory branch select
function findSelectList(type, width) {
  let adrList = [], cmdList = [];
  switch (type) {
    case DDR3:
    case DDR3L:
      adrList = DDR3_ADR.map(item => ({ value: item, label: item }));
      cmdList = DDR3_CMD.map(item => ({ value: item, label: item }));
      break;
    case DDR4:
      adrList = DDR4_ADR.map(item => ({ value: item, label: item }));
      cmdList = (width === X16 ? DDR4_CMD_96 : DDR4_CMD_78).map(item => ({ value: item, label: item }));
      break;
    case LPDDR4:
      adrList = LPDDR4_ADR.map(item => ({ value: item, label: item }));
      cmdList = LPDDR4_CMD.map(item => ({ value: item, label: item }));
      break;
    default: break;
  }

  let list = [{
    value: CLK,
    label: CLK,
    children: [{
      value: 'CLKP',
      label: 'CLKP'
    }, {
      value: 'CLKN',
      label: 'CLKN',
    }]
  }, {
    value: ADR,
    label: ADR,
    children: adrList
  }, {
    value: CMD,
    label: CMD,
    children: cmdList
  }];

  return list;
}

function getTopologyType(type) {
  if ([LPDDR4, LPDDR5].includes(type)) {
    return [POINT_TO_POINT/* , T */]
  }
  return [FLYBY]
}

function getDefaultNumberChannel(type, pcbType, width) {
  if ([LPDDR4, LPDDR5].includes(type) && pcbType === PACKAGE && width === X16) {
    return 1;
  }
  if ([LPDDR4, LPDDR5].includes(type) && pcbType === PACKAGE && width === X64) {
    return 4
  }
  if ([LPDDR4, LPDDR5].includes(type)) {
    return 2
  }
  return 1
}

export const
  DDR_PIN = {
    DDR3_x8_PIN: {
      DQ0: "B3",
      DQ1: "C7",
      DQ2: "C2",
      DQ3: "C8",
      DQ4: "E3",
      DQ5: "E8",
      DQ6: "D2",
      DQ7: "E7",
      DQSP0: "C3", // DQSP
      DQSN0: "D3", // DQSN
      DM0: "B7",
      CLKP: "F7",
      CLKN: "G7",
      A0: "K3",
      A1: "L7",
      A2: "L3",
      A3: "K2",
      A4: "L8",
      A5: "L2",
      A6: "M8",
      A7: "M2",
      A8: "N8",
      A9: "M3",
      A10: "H7",
      A11: "M7",
      A12: "K7",
      A13: "N3",
      BA0: "J2",
      BA1: "K8",
      BA2: "J3",
      RAS: "F3",
      CAS: "G3",
      WE: "H3",
      CS: "H2",
      CKE: "G9",
      ODT: "G1",
    },
    DDR3_x16_PIN: {
      DQ0: "E3",
      DQ1: "F7",
      DQ2: "F2",
      DQ3: "F8",
      DQ4: "H3",
      DQ5: "H8",
      DQ6: "G2",
      DQ7: "H7",
      DQSP0: "F3", // DPS0P
      DQSN0: "G3", // DQS0N
      DM0: "E7",
      DQ8: "D7",
      DQ9: "C3",
      DQ10: "C8",
      DQ11: "C2",
      DQ12: "A7",
      DQ13: "A2",
      DQ14: "B8",
      DQ15: "A3",
      DQSP1: "C7", // DQS1P
      DQSN1: "B7", // DQS1N
      DM1: "D3",
      CLKP: "J7",
      CLKN: "K7",
      A0: "N3",
      A1: "P7",
      A2: "P3",
      A3: "N2",
      A4: "P8",
      A5: "P2",
      A6: "R8",
      A7: "R2",
      A8: "T8",
      A9: "R3",
      A10: "L7",
      A11: "R7",
      A12: "N7",
      A13: "T3",
      BA0: "M2",
      BA1: "N8",
      BA2: "M3",
      RAS: "J3",
      CAS: "K3",
      WE: "L3",
      CS: "L2",
      CKE: "K9",
      ODT: "K1",
    },
    DDR4_x8_PIN: {
      DQ0: "C2",
      DQ1: "B7",
      DQ2: "D3",
      DQ3: "D7",
      DQ4: "D2",
      DQ5: "D8",
      DQ6: "E3",
      DQ7: "E7",
      DQSP0: "C3", // DQSP
      DQSN0: "B3", // DQSN
      DM0: "A7",
      CLKP: "F7",
      CLKN: "F8",
      A0: "L3",
      A1: "L7",
      A2: "M3",
      A3: "K7",
      A4: "K3",
      A5: "L8",
      A6: "L2",
      A7: "M8",
      A8: "M2",
      A9: "M7",
      A10: "J3",
      A11: "N2",
      A12: "J7",
      A13: "N8",
      A14: "H2",
      A15: "H7",
      A16: "H8",
      BA0: "K2",
      BA1: "K8",
      CS: "G7",
      CKE: "G3",
      ODT: "F3",
      BG0: "J2",
      BG1: "J8",
      ACT: "H3"
    },
    DDR4_x16_PIN: {
      DQ0: "G2",
      DQ1: "F7",
      DQ2: "H3",
      DQ3: "H7",
      DQ4: "H2",
      DQ5: "H8",
      DQ6: "J3",
      DQ7: "J7",
      DQSP0: "G3", // DQS0P
      DQSN0: "F3", // DQS0N
      DM0: "E7",
      DQ8: "A3",
      DQ9: "B8",
      DQ10: "C3",
      DQ11: "C7",
      DQ12: "C2",
      DQ13: "C8",
      DQ14: "D3",
      DQ15: "D7",
      DQSP1: "B7", // DQS1P
      DQSN1: "A7", // DQS1N
      DM1: "E2",
      CLKP: "K7",
      CLKN: "K8",
      A0: "P3",
      A1: "P7",
      A2: "R3",
      A3: "N7",
      A4: "N3",
      A5: "P8",
      A6: "P2",
      A7: "R8",
      A8: "R2",
      A9: "R7",
      A10: "M3",
      A11: "T2",
      A12: "M7",
      A13: "T8",
      A14: "L2",
      A15: "M8",
      A16: "L8",
      BA0: "N2",
      BA1: "N8",
      CS: "L7",
      CKE: "K2",
      ODT: "K3",
      BG0: "M2",
      ACT: "L3"
    },
    DDR5_x8_PIN: {
      DQ0: "C2",
      DQ1: "C8",
      DQ2: "B3",
      DQ3: "B7",
      DQ4: "E2",
      DQ5: "E8",
      DQ6: "E3",
      DQ7: "E7",
      DM0: "C7",
      DQSP0: "C3",
      DQSN0: "D3",
      CLKP: "G7",
      CLKN: "H7",
      CA0: "J3",
      CA1: "J7",
      CA2: "K3",
      CA3: "K7",
      CA4: "J2",
      CA5: "J8",
      CA6: "K2",
      CA7: "K8",
      CA8: "L3",
      CA9: "L7",
      CA10: "M2",
      CA11: "M8",
      CA12: "M3",
      CA13: "M7",
      CS0: "H3",
      ODT_CA: "G1",
      RESET: "M9",
    },
    DDR5_x16_PIN: {
      DQ0: "G2",
      DQ1: "G8",
      DQ2: "F3",
      DQ3: "F7",
      DQ4: "J2",
      DQ5: "J8",
      DQ6: "J3",
      DQ7: "J7",
      DQ8: "C2",
      DQ9: "C8",
      DQ10: "B3",
      DQ11: "B7",
      DQ12: "E2",
      DQ13: "E8",
      DQ14: "E3",
      DQ15: "E7",
      DM0: "G7",
      DM1: "C7",
      DQSP0: "G3",
      DQSN0: "H3",
      DQSP1: "C3",
      DQSN1: "D3",
      CLKP: "L7",
      CLKN: "M7",
      CA0: "N3",
      CA1: "N7",
      CA2: "P3",
      CA3: "P7",
      CA4: "N2",
      CA5: "N8",
      CA6: "P2",
      CA7: "P8",
      CA8: "R3",
      CA9: "R7",
      CA10: "T2",
      CA11: "T8",
      CA12: "T3",
      CA13: "T7",
      CS0: "M3",
      ODT_CA: "L1",
      RESET: "T9",
    }
  },
  LPDDR_PIN = {
    LPDDR4_x16_2_CHANNEL: {
      // Channel A
      DQ0_A: "B2",
      DQ1_A: "C2",
      DQ2_A: "E2",
      DQ3_A: "F2",
      DQ4_A: "F4",
      DQ5_A: "E4",
      DQ6_A: "C4",
      DQ7_A: "B4",
      DQ8_A: "B11",
      DQ9_A: "C11",
      DQ10_A: "E11",
      DQ11_A: "F11",
      DQ12_A: "F9",
      DQ13_A: "E9",
      DQ14_A: "C9",
      DQ15_A: "B9",
      DM0_A: "C3",
      DM1_A: "C10",
      DQSP0_A: "D3",
      DQSN0_A: "E3",
      DQSP1_A: "D10",
      DQSN1_A: "E10",
      CLKP_A: "J8",
      CLKN_A: "J9",
      CA0_A: "H2",
      CA1_A: "J2",
      CA2_A: "H9",
      CA3_A: "H10",
      CA4_A: "H11",
      CA5_A: "J11",
      CS0_A: "H4",
      CS1_A: "H3",
      CS2_A: "K5",
      CKE0_A: "J4",
      CKE1_A: "J5",
      CKE2_A: "K8",
      ODT_CA_A: "G2",
      RESET: "T11",

      // Channel B
      DQ0_B: "AA2",
      DQ1_B: "Y2",
      DQ2_B: "V2",
      DQ3_B: "U2",
      DQ4_B: "U4",
      DQ5_B: "V4",
      DQ6_B: "Y4",
      DQ7_B: "AA4",
      DQ8_B: "AA11",
      DQ9_B: "Y11",
      DQ10_B: "V11",
      DQ11_B: "U11",
      DQ12_B: "U9",
      DQ13_B: "V9",
      DQ14_B: "Y9",
      DQ15_B: "AA9",
      DM0_B: "Y3",
      DM1_B: "Y10",
      DQSP0_B: "W3",
      DQSN0_B: "V3",
      DQSP1_B: "W10",
      DQSN1_B: "V10",
      CLKP_B: "P8",
      CLKN_B: "P9",
      CA0_B: "R2",
      CA1_B: "P2",
      CA2_B: "R9",
      CA3_B: "R10",
      CA4_B: "R11",
      CA5_B: "P11",
      CS0_B: "R4",
      CS1_B: "R3",
      CS2_B: "N5",
      CKE0_B: "P4",
      CKE1_B: "P5",
      CKE2_B: "N8",
      ODT_CA_B: "T2",
    },
    LPDDR4_x16_4_CHANNEL: {
      // Channel A
      DQ0_A: "V2",
      DQ1_A: "U1",
      DQ2_A: "T2",
      DQ3_A: "R1",
      DQ4_A: "M2",
      DQ5_A: "M1",
      DQ6_A: "L1",
      DQ7_A: "K2",
      DQ8_A: "A18",
      DQ9_A: "B17",
      DQ10_A: "A16",
      DQ11_A: "B15",
      DQ12_A: "B11",
      DQ13_A: "A10",
      DQ14_A: "B9",
      DQ15_A: "A8",
      DM0_A: "N2",
      DM1_A: "A12",
      DQSP0_A: "R2",
      DQSN0_A: "P1",
      DQSP1_A: "B13",
      DQSN1_A: "A14",
      CLKP_A: "D2",
      CLKN_A: "C2",
      CA0_A: "J1",
      CA1_A: "H1",
      CA2_A: "C1",
      CA3_A: "B3",
      CA4_A: "A4",
      CA5_A: "B5",
      CS0_A: "F2",
      CS1_A: "G2",
      CKE0_A: "E1",
      CKE1_A: "F1",
      ODT_CA_A: "J2",
      RESET: "AR7",

      // Channel B
      DQ0_B: "W1",
      DQ1_B: "Y1",
      DQ2_B: "AA2",
      DQ3_B: "AB1",
      DQ4_B: "AE2",
      DQ5_B: "AE1",
      DQ6_B: "AF1",
      DQ7_B: "AG2",
      DQ8_B: "AT18",
      DQ9_B: "AR17",
      DQ10_B: "AT16",
      DQ11_B: "AR15",
      DQ12_B: "AT12",
      DQ13_B: "AT10",
      DQ14_B: "AR9",
      DQ15_B: "AT8",
      DM0_B: "AD2",
      DM1_B: "AT11",
      DQSP0_B: "AB2",
      DQSN0_B: "AC1",
      DQSP1_B: "AR13",
      DQSN1_B: "AT14",
      CLKP_B: "AN2",
      CLKN_B: "AP2",
      CA0_B: "AH1",
      CA1_B: "AJ1",
      CA2_B: "AP1",
      CA3_B: "AR3",
      CA4_B: "AT4",
      CA5_B: "AR5",
      CS0_B: "AL2",
      CS1_B: "AK2",
      CKE0_B: "AM1",
      CKE1_B: "AL1",
      ODT_CA_B: "AH2",

      // Channel C
      DQ0_C: "A19",
      DQ1_C: "B20",
      DQ2_C: "A21",
      DQ3_C: "B22",
      DQ4_C: "A25",
      DQ5_C: "A27",
      DQ6_C: "B28",
      DQ7_C: "A29",
      DQ8_C: "V35",
      DQ9_C: "U36",
      DQ10_C: "T35",
      DQ11_C: "R36",
      DQ12_C: "M35",
      DQ13_C: "M36",
      DQ14_C: "L36",
      DQ15_C: "K35",
      DM0_C: "B26",
      DM1_C: "N35",
      DQSP0_C: "B24",
      DQSN0_C: "A23",
      DQSP1_C: "R35",
      DQSN1_C: "P36",
      CLKP_C: "D35",
      CLKN_C: "E36",
      CA0_C: "A31",
      CA1_C: "B32",
      CA2_C: "F35",
      CA3_C: "F36",
      CA4_C: "G35",
      CA5_C: "H36",
      CS0_C: "B34",
      CS1_C: "A33",
      CKE0_C: "C35",
      CKE1_C: "C36",
      ODT_CA_C: "B30",

      // Channel D
      DQ0_D: "AT19",
      DQ1_D: "AR20",
      DQ2_D: "AT21",
      DQ3_D: "AR22",
      DQ4_D: "AR26",
      DQ5_D: "AT27",
      DQ6_D: "AR28",
      DQ7_D: "AT29",
      DQ8_D: "W36",
      DQ9_D: "Y36",
      DQ10_D: "AA35",
      DQ11_D: "AB36",
      DQ12_D: "AE35",
      DQ13_D: "AE36",
      DQ14_D: "AF36",
      DQ15_D: "AG35",
      DM0_D: "AT25",
      DM1_D: "AD35",
      DQSP0_D: "AR24",
      DQSN0_D: "AT23",
      DQSP1_D: "AB35",
      DQSN1_D: "AC36",
      CLKP_D: "AN35",
      CLKN_D: "AM36",
      CA0_D: "AT31",
      CA1_D: "AR32",
      CA2_D: "AL35",
      CA3_D: "AL36",
      CA4_D: "AK35",
      CA5_D: "AJ36",
      CS0_D: "AR34",
      CS1_D: "AT33",
      CKE0_D: "AP35",
      CKE1_D: "AP36",
      ODT_CA_D: "AR30",
    },
    LPDDR5_x16_2_CHANNEL: {
      // Channel A
      DQ0_A: "D1",
      DQ1_A: "C2",
      DQ2_A: "E2",
      DQ3_A: "D3",
      DQ4_A: "B5",
      DQ5_A: "C6",
      DQ6_A: "E6",
      DQ7_A: "F5",
      DQ8_A: "D15",
      DQ9_A: "C14",
      DQ10_A: "E14",
      DQ11_A: "D13",
      DQ12_A: "B11",
      DQ13_A: "C10",
      DQ14_A: "E10",
      DQ15_A: "F11",
      DM0_A: "A4",
      DM1_A: "A12",
      RDQS0_T_A: "B3",
      RDQS0_C_A: "C4",
      RDQS1_T_A: "B13",
      RDQS1_C_A: "C12",
      WCK0_T_A: "E4",
      WCK0_C_A: "D5",
      WCK1_T_A: "E12",
      WCK1_C_A: "D11",
      CLKP_A: "H9",
      CLKN_A: "J9",
      CA0_A: "G4",
      CA1_A: "H5",
      CA2_A: "G8",
      CA3_A: "H11",
      CA4_A: "G10",
      CA5_A: "H13",
      CA6_A: "G12",

      // Channel B
      DQ0_B: "V15",
      DQ1_B: "W14",
      DQ2_B: "U14",
      DQ3_B: "V13",
      DQ4_B: "Y11",
      DQ5_B: "W10",
      DQ6_B: "U10",
      DQ7_B: "T11",
      DQ8_B: "V1",
      DQ9_B: "W2",
      DQ10_B: "U2",
      DQ11_B: "V3",
      DQ12_B: "Y5",
      DQ13_B: "W6",
      DQ14_B: "U6",
      DQ15_B: "T5",
      DM0_B: "AA12",
      DM1_B: "AA4",
      RDQS0_T_B: "Y13",
      RDQS0_C_B: "W12",
      RDQS1_T_B: "Y3",
      RDQS1_C_B: "W4",
      WCK0_T_B: "U12",
      WCK0_C_B: "V11",
      WCK1_T_B: "U4",
      WCK1_C_B: "V5",
      CLKP_B: "P7",
      CLKN_B: "N7",
      CA0_B: "R12",
      CA1_B: "P11",
      CA2_B: "R8",
      CA3_B: "P5",
      CA4_B: "R6",
      CA5_B: "P3",
      CA6_B: "R4",
    },
    LPDDR5_x16_4_CHANNEL: {
      // Channel A
      DQ0_A: "B2",
      DQ1_A: "D2",
      DQ2_A: "C3",
      DQ3_A: "B4",
      DQ4_A: "G2",
      DQ5_A: "H3",
      DQ6_A: "J2",
      DQ7_A: "J3",
      DQ8_A: "B9",
      DQ9_A: "B8",
      DQ10_A: "C8",
      DQ11_A: "B7",
      DQ12_A: "H10",
      DQ13_A: "J9",
      DQ14_A: "J8",
      DQ15_A: "K10",
      DM0_A: "G4",
      DM1_A: "E9",
      RDQS0_T_A: "F2",
      RDQS0_C_A: "E2",
      RDQS1_T_A: "F8",
      RDQS1_C_A: "G9",
      WCK0_T_A: "E4",
      WCK0_C_A: "D3",
      WCK1_T_A: "D9",
      WCK1_C_A: "E8",
      CLKP_A: "H5",
      CLKN_A: "J6",
      CA0_A: "C5",
      CA1_A: "D5",
      CA2_A: "F6",
      CA3_A: "K6",
      CA4_A: "K7",
      CA5_A: "H7",
      CA6_A: "G7",

      // Channel B
      DQ0_B: "Y10",
      DQ1_B: "V10",
      DQ2_B: "W9",
      DQ3_B: "Y8",
      DQ4_B: "R8",
      DQ5_B: "P9",
      DQ6_B: "N10",
      DQ7_B: "N9",
      DQ8_B: "Y3",
      DQ9_B: "Y4",
      DQ10_B: "W4",
      DQ11_B: "Y5",
      DQ12_B: "P2",
      DQ13_B: "N3",
      DQ14_B: "N4",
      DQ15_B: "M2",
      DM0_B: "R10",
      DM1_B: "U3",
      RDQS0_T_B: "T10",
      RDQS0_C_B: "U10",
      RDQS1_T_B: "T4",
      RDQS1_C_B: "R3",
      WCK0_T_B: "U8",
      WCK0_C_B: "V9",
      WCK1_T_B: "V3",
      WCK1_C_B: "U4",
      CLKP_B: "P7",
      CLKN_B: "N6",
      CA0_B: "W7",
      CA1_B: "V7",
      CA2_B: "T6",
      CA3_B: "M6",
      CA4_B: "M5",
      CA5_B: "P5",
      CA6_B: "R5",

      // Channel C
      DQ0_C: "B12",
      DQ1_C: "D12",
      DQ2_C: "C13",
      DQ3_C: "B14",
      DQ4_C: "G14",
      DQ5_C: "H13",
      DQ6_C: "J12",
      DQ7_C: "J13",
      DQ8_C: "B19",
      DQ9_C: "B18",
      DQ10_C: "C18",
      DQ11_C: "B17",
      DQ12_C: "H20",
      DQ13_C: "J19",
      DQ14_C: "J18",
      DQ15_C: "K20",
      DM0_C: "G12",
      DM1_C: "E19",
      RDQS0_T_C: "F12",
      RDQS0_C_C: "E12",
      RDQS1_T_C: "F18",
      RDQS1_C_C: "G19",
      WCK0_T_C: "E14",
      WCK0_C_C: "D13",
      WCK1_T_C: "D19",
      WCK1_C_C: "E18",
      CLKP_C: "H15",
      CLKN_C: "J16",
      CA0_C: "C15",
      CA1_C: "D15",
      CA2_C: "F16",
      CA3_C: "K16",
      CA4_C: "K17",
      CA5_C: "H17",
      CA6_C: "G17",

      // Channel D
      DQ0_D: "Y20",
      DQ1_D: "V20",
      DQ2_D: "W19",
      DQ3_D: "Y18",
      DQ4_D: "R20",
      DQ5_D: "P19",
      DQ6_D: "N20",
      DQ7_D: "N19",
      DQ8_D: "Y13",
      DQ9_D: "Y14",
      DQ10_D: "W14",
      DQ11_D: "Y15",
      DQ12_D: "P12",
      DQ13_D: "N13",
      DQ14_D: "N14",
      DQ15_D: "M12",
      DM0_D: "R18",
      DM1_D: "U13",
      RDQS0_T_D: "T20",
      RDQS0_C_D: "U20",
      RDQS1_T_D: "T14",
      RDQS1_C_D: "R13",
      WCK0_T_D: "U18",
      WCK0_C_D: "V19",
      WCK1_T_D: "V13",
      WCK1_C_D: "U14",
      CLKP_D: "P17",
      CLKN_D: "N16",
      CA0_D: "W17",
      CA1_D: "V17",
      CA2_D: "T16",
      CA3_D: "M16",
      CA4_D: "M15",
      CA5_D: "P15",
      CA6_D: "R15",
    }
  }

export {
  DefaultPreLayout,
  PreLayoutSignal,
  findSelectList,
  PreLayoutDiffSignal,
  getLibraryData,
  getTopologyType,
  getDefaultNumberChannel,
  DefaultModelPreLayout
}